// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__XruMN","right":"styles_right__2K87j"};